<div [class.non-empty]="getRequests().length">
  @for (pr of getRequests(); track pr.id) {
    <div>{{pr.url}}</div>
  }
</div>
